import React,{useEffect} from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { Utils, NavigateTo } from '../../Utils.js';
import Form from '../Forms/Form/Form.js';
import './CheckoutSummary.css'; 

class CheckoutSummary extends React.Component {
  
  cartPostData = {};
  otherPostVariables = {};
  serverData = {};
  checkoutStepData = {};
  checkoutInitDone = false;

  drop_point_types = ['gls_drop_point'];

  show_address_form_types = ['delivery_address', 'same_day_delivery'];

  defaultState ={
    show: false,
    hiding: false,
    formData: {},
    formErrors: {  },
    fullCheckoutForm: {}, //ez megy át a szervernek, a telljes checkoutform
    paymentDeliveryMethods: {},
    deliveryAddresses: {},
    shoppingCart:{},
    sumTotalGross: 0,
    loaderVisible: 0,
    successSendingOrder: 0,
    successRedirect: '',
    select_reservation_selected_shop: 0
  };

  constructor(props) {
      super(props);
      this.state = {...this.defaultState};
  }

  toggle_loader(action){
    
    if(action=='show'){
      this.setState({loaderVisible:1});
    }else{
      this.setState({loaderVisible:0});
    }

  }

  init_checkout(post_data)
  {
    if(this.checkoutInitDone==true)
    {
      return true;
    }

    //fontos hogy a cartPostDataát minden lépésnel kuldeni kell kuponben elvesznk a beallitott kuponok
    if(post_data){
      this.cartPostData = post_data

      const init_checkout_post_data = {'is_app_init_checkout':1};

      post_data = {...this.cartPostData,...init_checkout_post_data}
    }
    
    Utils.get_server_data(
      '', 
      {ajax_event: 'checkout', APICACHE: 'false'}, 
      post_data
    )
    .then((res) => {
      this.setDatasFromResp(res);
      this.checkoutInitDone = true;
    });

  }

  set_form_data(formData,callback)
  {
    this.setState({formData:formData},()=>{
      if(typeof callback=='function'){ callback(); }
    });
  }

  setDatasFromResp(res)
  {
    this.serverData = res.checkout;
    
    if(res.checkout.form){
      const fullCheckoutForm = res.checkout.form;

      fullCheckoutForm.values.delivery_method_id = res.checkout.payment_delivery_methods.delivery_method_id;
      fullCheckoutForm.values.payment_method_id = res.checkout.payment_delivery_methods.payment_method_id;
      fullCheckoutForm.values.glsMapData = window.modals.CheckoutDeliveryRef.current.glsMapData;
      fullCheckoutForm.values.foxPostMapData = window.modals.CheckoutDeliveryRef.current.state.foxPostMapData;
      fullCheckoutForm.values.select_gls_shop_code = window.modals.CheckoutDeliveryRef.current.glsMapData?.select_gls_shop_code;
      fullCheckoutForm.values.select_foxpost_place_id = window.modals.CheckoutDeliveryRef.current.state.foxPostMapData?.select_foxpost_place_id;
      fullCheckoutForm.values.select_reservation_selected_shop = window.modals.CheckoutDeliveryRef.current.select_reservation_selected_shop;

      this.setState({fullCheckoutForm},()=>{this.setCheckoutStepsData(this.serverData); })
    }
    else
    {
      this.setCheckoutStepsData(this.serverData);
    }

    if(res.checkout.payment_delivery_methods){
      this.setState({paymentDeliveryMethods:res.checkout.payment_delivery_methods})
      this.setState({deliveryAddresses:res.checkout.delivery_addresses})
    }

    if(res.checkout.shopping_cart){
      this.setState({shoppingCart:res.checkout.shopping_cart})
    }

    if(res.checkout.sumtotal_gross){
      this.setState({sumTotalGross:res.checkout.sumtotal_gross})
    }

  }

  setCheckoutStepsData(serverData)
  {
    if(serverData?.fields_by_steps){
      Object.keys(serverData.fields_by_steps).map((val,index)=>{
        if(Object.keys(serverData.fields_by_steps[val]).length>0){
          this.checkoutStepData[val] = this.collectStepData(serverData.fields_by_steps[val]);
          this.checkoutStepData[val].form_hash = val + this.state.fullCheckoutForm.form_hash;
        }
      });

      if(this.checkoutStepData.step1){
        window.modals.CheckoutBillRef.current.set_form_data(this.checkoutStepData.step1);
      }

      if(this.checkoutStepData.step2){
        window.modals.CheckoutDeliveryRef.current.set_form_data(this.checkoutStepData.step2);
      }

      if(this.checkoutStepData.step3){
        window.modals.CheckoutPaymentRef.current.set_form_data(this.checkoutStepData.step3);
      }

      if(this.checkoutStepData.step4){
       this.set_form_data(this.checkoutStepData.step4);
      }
    }
  }

  collectStepData(step_fields)
  {
    const step_data = {items:{},messages:{},values:{}};

    if(step_fields.length>0)
    {
     
      step_fields.map((val,index)=>{

        if(this.state.fullCheckoutForm.items && this.state.fullCheckoutForm.items[val]){
          step_data.items[val] = this.state.fullCheckoutForm.items[val];
        }

        if(this.state.fullCheckoutForm.values && this.state.fullCheckoutForm.values[val]){
          step_data.values[val] = this.state.fullCheckoutForm.values[val];
        }

        if(this.state.fullCheckoutForm.messages && this.serverData?.form?.messages[val]){
          step_data.messages[val] = this.state.fullCheckoutForm.messages[val];
        }

        
      });
    }

    return step_data;
  }

  show() {
    this.setState({show: true});
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  handle_change(event, formDataKey, force_value = null) {

    const formData = this.state.formData;
    formData[formDataKey] = force_value !== null ? force_value : event.target.value;
    this.setState({formData});

  }

  
  get_checkout_form_data(form_key){
    if(this.state.fullCheckoutForm?.values && this.state.fullCheckoutForm?.values[form_key])
    {
      return this.state.fullCheckoutForm?.values[form_key];
    }
  }

  set_from_data_from_step(step,formData,callback)
  {
    const fullFormData = {...this.state.fullCheckoutForm};

    if(Object.keys(formData).length>0)
    {
      Object.keys(formData).map((fieldname,index)=>{
        fullFormData.values[fieldname] = formData[fieldname];
      });

      this.setState({fullCheckoutForm:fullFormData},()=>{this.sendCheckoutForm(step,callback)});
    }
  }

  setOtherPostVariables(add_to_others)
  {
    const others = add_to_others!==undefined ? add_to_others : {};

    others.is_form = 1;
    others.ready_form = 1;
    others.multi_steps_checkout_sending_order_next_x = true;

    this.otherPostVariables = {...this.otherPostVariables, ...others};
  }

  sendCheckoutForm(step,callback)
  {
    this.setOtherPostVariables({multi_steps_checkout_step_number:step});

    let post_data = {...this.state.fullCheckoutForm.values,...this.cartPostData,...this.otherPostVariables};
  
    Utils.get_server_data(
      '', 
      {ajax_event: 'checkout', APICACHE: 'false'}, 
      post_data
    )
    .then((res) => {
      //simplepay
      if (res?.checkout?.payu_content && res.checkout?.payu_content.length>0)
      {
        const parseHtml = html => new DOMParser().parseFromString(html, 'text/html').body.innerHTML;

        document.getElementById('checkout_summary_payu_content').innerHTML = parseHtml(res.checkout.payu_content); 
        document.getElementById("PayUForm").submit();  
      } 
      //revolut
      else if (res?.checkout?.revolut_url && res.checkout?.revolut_url.length>0)
      {
        window.location.href = res.checkout.revolut_url;
      }
      //barion
      else if (res?.checkout?.barion_url && res.checkout?.barion_url.length>0)
      {
        window.location.href = res.checkout.barion_url;
      }
      //sikeres rendelés feladás
      else if(res.checkout?.success_sending_order)
      {
        if(res.checkout?.redirect_url)
        {
          this.setState({successRedirect:res.checkout.redirect_url},()=>{
            this.setState({...this.defaultState});
            window.AppRef.current.get_update_shopping_cart();
            window.modals.ShoppingCartRef.current.hide();
          });
        }
      }
      else
      {
        this.setDatasFromResp(res);

        if(parseInt(step)===1){
          if(res.checkout?.form?.messages && res.checkout?.form?.messages.length===0){
            window.modals.CheckoutBillRef.current.toggle(this)
          }
        }
  
        if(parseInt(step)===2){
          if(res.checkout?.form?.messages && res.checkout?.form?.messages.length===0){
            window.modals.CheckoutDeliveryRef.current.toggle(this)
          }
        }
  
        if(parseInt(step)===3){
          if(res.checkout?.form?.messages && res.checkout?.form?.messages.length===0){
            window.modals.CheckoutPaymentRef.current.toggle(this)
          }
        }
        
        if(typeof callback=='function')
        {
          callback();
        }
      }
     
    });
  }

  render() {

    const {formData, formErrors, show, hiding, shoppingCart, fullCheckoutForm, paymentDeliveryMethods } = this.state;

    if (!show) return '';


    if(this.state.successRedirect){
      return <NavigateTo toURL={'content/'+this.state.successRedirect}></NavigateTo>
    }

    return <div className={`container floating_container page_checkout page_checkout_summary ${hiding ? 'out' : ''}`}>
          <div className="content">
          
          <PageHeader parent_ref={this} no_close title={i18n.t('checkoutOrder')} />

          <div className='container_inner'>
            <div id="checkout_summary_payu_content"></div>
            {(this.state.loaderVisible) ? <div className='loader_cont'><div className='loader'><ReactSVG src='assets/images/dorko_loader.svg'></ReactSVG></div></div> : ''}
            <div className="checkout_step_data">
              <div className="checkout_step_data_title">
                <label>{i18n.t('checkoutBillData')}</label>
                <div className="back"><ReactSVG src="assets/images/edit_black.svg" onClick={() => window.modals.CheckoutBillRef.current.toggle(this) } /></div>
              </div>
              <div className="checkout_step_data_content">
                <div className="row">
                  <label>{i18n.t('checkoutBillName')}:</label>
                  <p>{this.get_checkout_form_data('bill_name_txt')}</p>
                </div>
                {(this.state.fullCheckoutForm?.values?.bill_tax_number_txt) ?
                  <div className="row">
                    <label>{i18n.t('checkoutBillTaxnumber')}:</label>
                    <p>{this.get_checkout_form_data('bill_tax_number_txt')}</p>
                  </div>
                :''} 
                <div className="row">
                  <label>{i18n.t('checkoutCity')}:</label>
                  <p>{this.get_checkout_form_data('bill_city_txt')}</p>
                </div>
                <div className="row">
                  <label>{i18n.t('checkoutAddress')}:</label>
                  <p>{this.get_checkout_form_data('bill_street_txt')}</p>
                </div>
                <div className="row">
                  <label>{i18n.t('checkoutZip')}:</label>
                  <p>{this.get_checkout_form_data('bill_zip_txt')}</p>
                </div>
                <div className="row">
                  <label>{i18n.t('checkoutPhone')}:</label>
                  <p>{this.get_checkout_form_data('phone_txt')}</p>
                </div>
              </div>
            </div>

            <div className="checkout_step_data">
              <div className="checkout_step_data_title">
                <label>{i18n.t('checkoutDelivery')}</label>
                {this.is_filled_bill_datas() ? <div className="back"><ReactSVG src="assets/images/edit_black.svg" onClick={() => window.modals.CheckoutDeliveryRef.current.toggle(this) } /></div>: ''}
              </div>
              <div className="checkout_step_data_content">
                {this.display_delivery_summary()}
              </div> 
            </div>

            <div className="checkout_step_data">
              <div className="checkout_step_data_title">
                <label>{i18n.t('checkoutPayment')}</label>
                {this.is_filled_delivery_datas() ? <div className="back"><ReactSVG src="assets/images/edit_black.svg" onClick={() => window.modals.CheckoutPaymentRef.current.toggle(this)} /></div>: ''}
              </div>
              <div className="checkout_step_data_content">
                {this.display_payment_summary()}
              </div> 
            </div>

            <div className="checkout_summary">
              
              <div className="row">
                <label>{i18n.t('shoppingCartProductsTotal')}:</label>
                <p>{shoppingCart.sum_products_gross}</p>
              </div>
              {(shoppingCart?.discounts?.coupon_system?.coupon_gross) ?
                <div className='checkout_coupon_gross row'>
                  <label className='coupon_label'>{shoppingCart.discounts.coupon_system.coupon_number} <br/>{shoppingCart.discounts.coupon_system.coupon_label}</label>
                  <p className='coupon_gross_val'>-{shoppingCart.discounts.coupon_system.coupon_gross}</p> 
                </div> 
              : ''}
              {(shoppingCart?.discounts?.ugyfelkartya?.ugyfelkartya_valid && shoppingCart?.discounts?.ugyfelkartya?.ugyfelkartya_used_gross) ?
                <div className='checkout_coupon_gross row'>
                  <label className='coupon_label'>{i18n.t('shoppingCartLoyaltiSummingRow')} {shoppingCart.discounts.ugyfelkartya.ugyfelkartya_number}</label>
                  <p className='coupon_gross_val'>-{shoppingCart.discounts.ugyfelkartya.ugyfelkartya_used_gross}</p> 
                </div> 
                : ''
              }
              {parseFloat(paymentDeliveryMethods.delivery_cost_gross_s)>0 && paymentDeliveryMethods.delivery_method_id ?
              <div className="row">
                <label>{paymentDeliveryMethods.delivery_cost_name}:</label>
                <p className="coupon_gross_val">{paymentDeliveryMethods.delivery_cost_gross}</p>
              </div>
               : ''}

               {parseFloat(paymentDeliveryMethods.payment_cost_gross_s)>0 && paymentDeliveryMethods.payment_method_id ? 
                <div className="row">
                  <label>{paymentDeliveryMethods.payment_cost_name}:</label>
                  <p className="coupon_gross_val">{paymentDeliveryMethods.payment_cost_gross}</p>
                </div>
               : ''
               }
              
              <div className="row total">
                <label>{i18n.t('shoppingCartTotal')}:</label>
                <p>{this.state.sumTotalGross}</p>
              </div>

              <div className="row">

              <Form 
              key={this.state.formData.form_hash}
              name="checkout_summery" 
              form_data={this.state.formData} 
              on_save={(form_data,callback)=>{this.toggle_loader('show'); this.set_from_data_from_step('4',form_data,()=>{this.toggle_loader('hide')})}} 
              form_source="props" 
              submit_text={i18n.t('checkoutSendOrder')} 
              parent={this} />

              </div>
              <p className="checkout_vat_text" dangerouslySetInnerHTML={{__html: i18n.t('checkoutVatText')}}></p>
              
            </div>
            
            
          </div>

          </div>
      </div>;
  }

  is_filled_bill_datas() {
    let bill_name = this.get_checkout_form_data('bill_name_txt');
    if (typeof bill_name == 'undefined') bill_name = '';

    let phone = this.get_checkout_form_data('phone_txt');
    if (typeof phone == 'undefined') phone = '';

    return bill_name.length > 0 && phone.length >= 8;
  }

  is_filled_delivery_datas() {
    let result = true;

    const { paymentDeliveryMethods } = this.state;

    let delivery_method = parseInt(this.get_checkout_form_data('delivery_method_id'));
    if (isNaN(delivery_method)) delivery_method = 0;
    
    // nincs megadva
    if (delivery_method === 0)
    {
      result = false;
    }

    // foxpost
    if (delivery_method && paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method_type == 'foxpost')
    {
      const foxPostMapData = this.get_checkout_form_data('foxPostMapData');

      if (!foxPostMapData?.select_foxpost_place_id?.length) {
        result = false;
      }
    }
    // csomagpont, de nincs kiválasztva
    if (delivery_method && this.drop_point_types.includes(paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method_type))
    {
      const glsMapData = this.get_checkout_form_data('glsMapData');

      if (!glsMapData?.select_gls_shop_code?.length) {
        result = false;
      }
    }
    // cím
    else if (delivery_method && this.show_address_form_types.includes(paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method_type))
    {
      let postal_address = parseInt(this.get_checkout_form_data('postal_address_int'));
      if (isNaN(postal_address)) postal_address = 0;

      // Megegyezik a számlázási címmel, de a számlázási cím nincs kitöltve
      if (!postal_address && !this.is_filled_bill_datas())
      { 
        result = false;
      }

      // Nem egyezik meg a számlázási címmel és nincs szállítási név
      if (postal_address) 
      {
        let postal_name = this.get_checkout_form_data('postal_name_txt');
        if (typeof postal_name == 'undefined') postal_name = '';
        
        if (!postal_name.length)
        {
          result = false;
        }
      }
    }

    return result;
  }

  display_delivery_summary() {
    const { paymentDeliveryMethods, deliveryAddresses } = this.state;

    let delivery_method = parseInt(this.get_checkout_form_data('delivery_method_id'));
    if (isNaN(delivery_method)) delivery_method = 0;
    
    let filled_bill_datas = this.is_filled_bill_datas();
    
    // 
    if (!filled_bill_datas)
    {
      return <p className="empty" dangerouslySetInnerHTML={{__html: i18n.t('checkoutPaymentBillEmpty')}}></p>;
    }
    // számmítási mód nincs megadva
    else if (delivery_method == 0)
    {
      return <p className="empty" dangerouslySetInnerHTML={{__html: i18n.t('checkoutDeliveryEmpty')}}></p>;
    }
    else {

      // foxpost
      if (paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method_type == 'foxpost')
      {
        const foxPostMapData = this.get_checkout_form_data('foxPostMapData');

        return <>
          <p className="empty">{paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method}</p>
          <div className="row">
            <p>{foxPostMapData.select_foxpost_place_id}</p>
          </div>
          <div className="row">
            <p>{foxPostMapData.select_foxpost_name}, {foxPostMapData.select_foxpost_address}</p>
          </div> 
        </>;
      }

      // csomagpont
      if (this.drop_point_types.includes(paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method_type))
      {
        const glsMapData = this.get_checkout_form_data('glsMapData');

        return <>
          <p className="empty">{paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method}</p>
          <div className="row">
            <p>{glsMapData.select_gls_shop_code}</p>
          </div>
          <div className="row">
            <p>{glsMapData.select_gls_pcl_shop_zipcode} {glsMapData.select_gls_pcl_shop_city} {glsMapData.select_gls_pcl_shop_address}</p>
          </div> 
        </>;
      }

      else if (['reservation', 'reservation_with_transport'].includes(paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method_reservation_type_txt))
      {
        return typeof this.state.paymentDeliveryMethods.delivery_methods_shops_data[this.state.fullCheckoutForm.values.select_reservation_selected_shop] !== 'undefined' ? <>
          <p className="empty" dangerouslySetInnerHTML={{__html: paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method}}></p>
          <div className="row reservation_selected_shop_row">
              <label>{i18n.t('reservationSelectedShop')}</label>
              <p>{this.state.paymentDeliveryMethods.delivery_methods_shops_data[this.state.fullCheckoutForm.values.select_reservation_selected_shop].label}</p>
            </div> 
        </> : '';
      }

      // cím
      else if (this.show_address_form_types.includes(paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method_type))
      {
        let postal_address = parseInt(this.get_checkout_form_data('postal_address_int'));
        if (isNaN(postal_address)) postal_address = 0;

        // Megegyezik a számlázási címmel
        if (postal_address === 0)
        {
          return <>
            <p className="empty" dangerouslySetInnerHTML={{__html: paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method}}></p>
            <div className="row">
              <label>{i18n.t('checkoutBillName')}:</label>
              <p>{this.get_checkout_form_data('bill_name_txt')}</p>
            </div> 
            <div className="row">
              <label>{i18n.t('checkoutCity')}:</label>
              <p>{this.get_checkout_form_data('bill_city_txt')}</p>
            </div> 
            <div className="row">
              <label>{i18n.t('checkoutAddress')}:</label>
              <p>{this.get_checkout_form_data('bill_street_txt')}</p>
            </div>
            <div className="row">
              <label>{i18n.t('checkoutZip')}:</label>
              <p>{this.get_checkout_form_data('bill_zip_txt')}</p>
            </div>
          </>;
        } 
        // Nem egyezik meg a számlázási címmel
        else if (postal_address === 1)
        {
          return <>
            <p className="empty" dangerouslySetInnerHTML={{__html: paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method}}></p>
            <div className="row">
              <label>{i18n.t('checkoutDeliveryName')}:</label>
              <p>{this.get_checkout_form_data('postal_name_txt')}</p>
            </div> 
            <div className="row">
              <label>{i18n.t('checkoutCity')}:</label>
              <p>{this.get_checkout_form_data('postal_city_txt')}</p>
            </div>
            <div className="row">
              <label>{i18n.t('checkoutAddress')}:</label>
              <p>{this.get_checkout_form_data('postal_street_txt')}</p>
            </div>
            <div className="row">
              <label>{i18n.t('checkoutZip')}:</label>
              <p>{this.get_checkout_form_data('postal_zip_txt')}</p>
            </div>
          </>;
        }
        else {
          let address = Object.values(deliveryAddresses).filter(address => parseInt(address.id) == postal_address);

          if (address.length)
          {
            address = address[0];
          
            return <>
              <p className="empty" dangerouslySetInnerHTML={{__html: paymentDeliveryMethods.delivery_methods[delivery_method].delivery_method}}></p>
              <div className="row">
                <label>{i18n.t('checkoutDeliveryName')}:</label>
                <p>{address.postal_name_txt}</p>
              </div> 
              <div className="row">
                <label>{i18n.t('checkoutCity')}:</label>
                <p>{address.postal_city_txt}</p>
              </div>
              <div className="row">
                <label>{i18n.t('checkoutAddress')}:</label>
                <p>{address.postal_street_txt}</p>
              </div>
              <div className="row">
                <label>{i18n.t('checkoutZip')}:</label>
                <p>{address.postal_zip_txt}</p>
              </div>
            </>;
          }
        }
      }

    }
  }

  display_payment_summary() {
    const { paymentDeliveryMethods } = this.state;

    let filled_bill_datas = this.is_filled_bill_datas();
    let filled_delivery_datas = this.is_filled_delivery_datas();
    
    let delivery_method = parseInt(this.get_checkout_form_data('delivery_method_id'));
    if (isNaN(delivery_method)) delivery_method = 0;

    let payment_method = parseInt(this.get_checkout_form_data('payment_method_id'));
    if (isNaN(payment_method)) payment_method = 0;
    
    return <>
      {/* számlázási adat nincs megadva */}
      {!filled_bill_datas ? <p className="empty" dangerouslySetInnerHTML={{__html: i18n.t('checkoutPaymentBillEmpty')}}></p> : '' }
      {/* szállítási adat nincs megadva */}
      {!filled_delivery_datas ? <p className="empty" dangerouslySetInnerHTML={{__html: i18n.t('checkoutDeliveryEmpty')}}></p> : ''}
      {/* van számlázási és szállítási adat de nincs fizetési mód */}
      {filled_bill_datas && filled_delivery_datas && payment_method == 0 ? <p className="empty" dangerouslySetInnerHTML={{__html: i18n.t('checkoutPaymentEmpty')}}></p> : ''}
      {/* van számlázási és szállítási adat és fizetési mód */}
      {filled_bill_datas && filled_delivery_datas && payment_method ? <p className="empty">{paymentDeliveryMethods.payment_methods[payment_method].payment_method}</p> : ''}
    </>;
  }
}

export default CheckoutSummary;